export default (el) => {
  if (!el) {
    el = document.querySelector(".js-modal") as HTMLElement;
  }

  if (!el) {
    return;
  }

  const closeModals = Array.from(el.querySelectorAll(".js-modal-close"));
  const video = el.querySelector(".js-modal__video") as HTMLVideoElement;

  // if video, when video ends, close modal
  if (video) {
    video.addEventListener("ended", () => {
      document.body.classList.remove("showing-modal");
      el.classList.remove("active");
    });
  }

  // add esc key listener to stop video and hide modals
  document.addEventListener("keydown", (e) => {
    if (e.keyCode === 27) {
      document.body.classList.remove("showing-modal");
      el.classList.remove("active");

      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }
  });

  for (let closeModal of closeModals) {
    closeModal.addEventListener("click", () => {
      document.body.classList.remove("showing-modal");
      el.classList.remove("active");

      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  }
};
